import { gql } from 'graphql-request'

export const totalAppointmentsInQuarterQuery = gql`
  query totalAppointmentsInQuarter($quarter_id: Int) {
    totalAppointmentsInQuarter(quarter_id: $quarter_id)
  }
`
export const pastAppointmentsInQuarterQuery = gql`
  query pastAppointmentsInQuarter($quarter_id: Int) {
    pastAppointmentsInQuarter(quarter_id: $quarter_id)
  }
`
export const futureAppointmentsInQuarterQuery = gql`
  query futurAppointmentsInQuarter($quarter_id: Int) {
    futurAppointmentsInQuarter(quarter_id: $quarter_id)
  }
`
export const summaryOfAppointmentsInQuarterQuery = gql`
  query summaryOfAppointmentsInQuarter($quarter_id: Int) {
    summaryOfAppointmentsInQuarter(quarter_id: $quarter_id) {
      summary {
        quarter_id
        past
        future
      }
      projects {
        id
        name
        past
        future
        contact_goal
        amount_summary
      }
    }
  }
`
